<template>
  <div class="orderDetail contentCenter">
    <nav class="currentLocation">
      <ul class="display-flex">
        <li>
          <span>您的位置</span>
        </li>
        <li>
          <span>我的订单</span>
        </li>
        <li>
          <span>详情</span>
        </li>
      </ul>
    </nav>
    <div class="course display-flex">
      <img class="proPic" :src="detail.imgUrl" alt />
      <div class="info flex-1">
        <h4 class="display-flex justify-content-space-between">
          <h6>会计人员继续教育{{ detail.studytime }}学时</h6>

          <p class="price">
            <span>￥</span>
            {{ detail.money }}
          </p>
        </h4>
        <!-- <p class="count">已有1632885人学习</p> -->
        <div class="btn display-flex align-items-center">
          <button type="button" v-if="detail.paystate == '已支付'">已支付</button>
          <button type="button" class="payBtn" v-if="detail.paystate == '待支付'" @click="handlePay">支付</button>
          <div class="proof" @click="handleOpen">
            <img src="../../assets/img/receipt.png" alt />电子发票
          </div>
        </div>
      </div>
    </div>
    <div class="detail">
      <div class="publicTitle display-flex justify-content-space-between align-items-center">
        <h5 class="h5">
          <img src="../../assets/img/titleLine.png" alt /> 订单详情
        </h5>
      </div>
      <div class="detailItem display-flex justify-content-space-around">
        <div class="lf">
          <p>
            <span>订单号</span>
            {{ detail.orderno }}
          </p>
          <p>
            <span>下单时间</span>
            {{ detail.createtime }}
          </p>
          <p>
            <span>商家</span> 爱尔信继续教育平台
          </p>
        </div>
        <div class="rg">
          <p>
            <span>当前状态</span>
            {{ detail.paystate == "待支付" ? "未支付" : "已支付" }}
          </p>
          <p>
            <span>支付时间</span>
            {{ detail.updatetime }}
          </p>
          <p>
            <span>支付方式</span>
            {{ detail.payway }}
          </p>
          <p>
            <span>支付单号</span>
            {{ detail.tradeno }}
          </p>
        </div>
      </div>
    </div>

    <div v-if="isModal">
      <Invoice @loadData="loadData" ref="invoice" />
    </div>
  </div>
</template>

<script>
import Invoice from "@/components/userCenter/Invoice.vue";
import { postData, showLoading, EventBus } from "../../assets/api/api.js";
export default {
  name: "orderDetail",
  components: { Invoice },
  data() {
    return {
      isModal: false,
      orderId: "",
      detail: {}
    };
  },
  created() {
    this.orderId = this.$route.query.id;
    this.loadData();
  },
  mounted() {
    localStorage.setItem("comName", "Order");
  },
  computed: {},
  methods: {
    handleOpen() {
      this.isModal = true;
      this.$nextTick(() => {
        this.$refs.invoice.isShowModal = true;
        this.$refs.invoice.orderId = this.orderId;
        this.$refs.invoice.invoiceStatus = this.detail.invoiceStatus;
        this.$refs.invoice.invoiceFailReason = this.detail.invoiceFailReason;
      });
    },
    handlePay() {
      this.$router.push({
        path: "/Pay",
        query: {
          isOrderList: true,
          orderId: this.$route.query.id
        }
      });
    },
    loadData() {
      const { orderId } = this;
      var params = {
        orderId
      };
      // 1 已支付   0未支付
      showLoading();
      postData("sale/orderDetail", params).then(res => {
        res.data.money = (+res.data.money).toFixed(2);
        this.detail = res.data;
      });
    },
    handleSave() {
      var img = document.getElementById("proofImg").getAttribute("src");
      window.open(img);
      this.isModal = false;
    }
  }
};
</script>
<style lang="scss" scoped>
button {
  cursor: pointer;
  border: none;
  outline: none;
  margin-right: 18px;
}
.detail {
  .publicTitle {
    padding: 15px 0;
    // border-bottom: 1px solid #f5f2f5;
    margin-bottom: 15px;
    .h5 {
      img {
        vertical-align: middle;
      }
      font-size: 16px;
      color: rgba(34, 34, 34, 1);
    }
  }
}

.course {
  background: #fff;
  padding: 20px 30px 20px 20px;
  .proPic {
    width: 200px;
    height: 120px;
    margin-right: 30px;
  }
  .info {
    .count {
      color: rgba(153, 153, 153, 1);
      line-height: 16px;
    }
    .btn {
      margin-top: 26px;
      .proof {
        cursor: pointer;
        img {
          vertical-align: middle;
        }
      }
      .payBtn {
        background: #ec6941;
        color: #fff;
      }
      button {
        width: 100px;
        line-height: 36px;
        background: rgba(238, 238, 238, 1);
        border-radius: 3px;
        color: rgba(187, 187, 187, 1);
        margin-right: 18px;
      }
    }
    h4 {
      font-size: 18px;
      color: rgba(34, 34, 34, 1);
      line-height: 40px;

      .price {
        font-size: 30px;
        font-weight: bold;
        color: rgba(236, 105, 65, 1);
        span {
          display: inline-block;
          margin-right: 8px;
        }
      }
    }
  }
}
.detail {
  margin-bottom: 50px;
  background: #fff;
  margin-top: 20px;
  padding-left: 15px;
  .detailItem {
    margin-top: 38px;
    padding-bottom: 115px;
    p {
      color: rgba(102, 102, 102, 1);
      line-height: 16px;
      margin-bottom: 22px;
      span {
        text-align: right;
        width: 60px;
        color: rgba(153, 153, 153, 1);
        display: inline-block;
        margin-right: 26px;
      }
    }
  }
}
</style>
